export default "__VITE_ASSET__D5g0rDiB__"